export const CREATE_METADATA = 'CREATE_METADATA';
export const FETCH_METADATA_LIST = 'FETCH_METADATA_LIST';
export const FETCH_SINGLE_METADATA = 'FETCH_SINGLE_METADATA';
export const UPDATE_METADATA = 'UPDATE_METADATA';
export const DELETE_METADATA = 'DELETE_METADATA';
